import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';

export const catalogReactTranslation = TranslationBlueprint.make({
  name: 'catalog-react',
  params: {
    resource: createTranslationMessages({
      ref: catalogReactTranslationRef,
      full: false,
      messages: {
        'catalogFilter.title': 'Filters',
        'catalogFilter.buttonTitle': 'Filters',
        'entityKindPicker.title': 'Soort',
        'entityKindPicker.errorMessage':
          'De soorten entiteiten konden niet worden geladen',
        'entityLifecyclePicker.title': 'Levenscyclus',
        'entityNamespacePicker.title': 'Naamruimte',
        'entityOwnerPicker.title': 'Eigenaar',
        'entityProcessingStatusPicker.title': 'Verwerkingsstatus',
        'entityTagPicker.title': 'Tags',
        'entityPeekAheadPopover.title':
          'Open de entiteit om alle tags te bekijken.',
        'entityPeekAheadPopover.emailCardAction.title':
          'Stuur een e-mail naar {{email}}',
        'entityPeekAheadPopover.emailCardAction.subTitle': 'mailto {{email}}',
        'entityPeekAheadPopover.emailCardAction.ariaLabel': 'E-mail',
        'entityPeekAheadPopover.entityCardActionsAriaLabel': 'Toon',
        'entityPeekAheadPopover.entityCardActionsTitle': 'Toon details',
        'entitySearchBar.placeholder': 'Zoek',
        'entityTypePicker.title': 'Type',
        'entityTypePicker.errorMessage':
          'De typen entiteiten konden niet worden geladen',
        'entityTypePicker.optionAllTitle': 'alle',
        'favoriteEntity.addToFavorites': 'Voeg toe aan favorieten',
        'favoriteEntity.removeFromFavorites': 'Verwijder uit favorieten',
        'inspectEntityDialog.title': 'Entiteit inspecteren',
        'inspectEntityDialog.closeButtonTitle': 'Sluit',
        'inspectEntityDialog.ancestryPage.title': 'Herkomst',
        'inspectEntityDialog.ancestryPage.description':
          'Dit is de herkomst van de entiteiten boven de huidige: de keten of ketens van entiteiten tot aan de huidige, waarbij {{processorsLink}} onderliggende entiteiten uitstuurden die uiteindelijk tot de huidige entiteit hebben geleid. Dit is een heel ander mechanisme dan relaties.',
        'inspectEntityDialog.ancestryPage.processorsLink': 'processors',
        'inspectEntityDialog.colocatedPage.title': 'Op dezelfde plek',
        'inspectEntityDialog.colocatedPage.description':
          'Dit zijn de entiteiten op dezelfde plek als deze entiteit: ze komen uit dezelfde gegevensbron (bijvoorbeeld hetzelfde YAML-bestand) of uit dezelfde oorsprong (bijvoorbeeld de oorspronkelijk geregistreerde URL).',
        'inspectEntityDialog.colocatedPage.alertNoLocation':
          'De entiteit had geen locatiegegevens.',
        'inspectEntityDialog.colocatedPage.alertNoEntity':
          'Er stonden geen andere entiteiten op deze locatie.',
        'inspectEntityDialog.colocatedPage.locationHeader':
          'Op dezelfde locatie',
        'inspectEntityDialog.colocatedPage.originHeader':
          'Met dezelfde oorsprong',
        'inspectEntityDialog.colocatedPage.entityListAriaLabel':
          'Entiteiten op dezelfde plek',
        'inspectEntityDialog.jsonPage.title': 'Entiteit als JSON',
        'inspectEntityDialog.jsonPage.description':
          'Dit zijn de ruwe gegevens van de entiteit zoals ontvangen uit de catalogus, in JSON-formaat.',
        'inspectEntityDialog.overviewPage.title': 'Overzicht',
        'inspectEntityDialog.overviewPage.relation.title': 'Relaties',
        'inspectEntityDialog.overviewPage.status.title': 'Status',
        'inspectEntityDialog.overviewPage.identity.title': 'Identiteit',
        'inspectEntityDialog.overviewPage.metadata.title': 'Metadata',
        'inspectEntityDialog.overviewPage.annotations': 'Annotaties',
        'inspectEntityDialog.overviewPage.labels': 'Labels',
        'inspectEntityDialog.overviewPage.tags': 'Tags',
        'inspectEntityDialog.overviewPage.copyAriaLabel': 'Kopieer {{label}}',
        'inspectEntityDialog.overviewPage.copiedStatus': 'Gekopieerd',
        'inspectEntityDialog.overviewPage.helpLinkAriaLabel': 'Meer informatie',
        'inspectEntityDialog.yamlPage.title': 'Entiteit als YAML',
        'inspectEntityDialog.yamlPage.description':
          'Dit zijn de ruwe gegevens van de entiteit zoals ontvangen uit de catalogus, in YAML-formaat.',
        'inspectEntityDialog.tabNames.overview': 'Overzicht',
        'inspectEntityDialog.tabNames.ancestry': 'Herkomst',
        'inspectEntityDialog.tabNames.colocated': 'Op dezelfde plek',
        'inspectEntityDialog.tabNames.json': 'Ruwe JSON',
        'inspectEntityDialog.tabNames.yaml': 'Ruwe YAML',
        'inspectEntityDialog.tabsAriaLabel': 'Opties voor inspecteren',
        'unregisterEntityDialog.title':
          'Weet je zeker dat je de registratie van deze entiteit wilt intrekken?',
        'unregisterEntityDialog.cancelButtonTitle': 'Annuleer',
        'unregisterEntityDialog.deleteButtonTitle': 'Verwijder entiteit',
        'unregisterEntityDialog.deleteEntitySuccessMessage':
          'Entiteit {{entityName}} is verwijderd',
        'unregisterEntityDialog.bootstrapState.title':
          'Je kunt de registratie van deze entiteit niet intrekken, omdat ze uit een beschermde Backstage-configuratie komt (locatie "{{location}}"). Denk je dat dit niet klopt, neem dan contact op met de beheerder van {{appTitle}}.',
        'unregisterEntityDialog.bootstrapState.advancedDescription':
          'Je kunt de entiteit zelf uit de catalogus verwijderen. Doe dit alleen als je weet dat het catalogusbestand op de oorspronkelijke locatie is verwijderd of verplaatst. Is dat niet zo, dan verschijnt de entiteit weer zodra de catalogus de volgende keer ververst.',
        'unregisterEntityDialog.bootstrapState.advancedOptions':
          'Geavanceerde opties',
        'unregisterEntityDialog.onlyDeleteStateTitle':
          'Deze entiteit lijkt niet van een geregistreerde locatie te komen. Je kunt haar daarom alleen direct uit de catalogus verwijderen.',
        'unregisterEntityDialog.unregisterState.title':
          'Met deze actie trek je de registratie van de volgende entiteiten in:',
        'unregisterEntityDialog.unregisterState.subTitle':
          'Op de volgende locatie:',
        'unregisterEntityDialog.unregisterState.description':
          'Ongedaan maken doe je door de entiteit opnieuw te registreren in {{appTitle}}.',
        'unregisterEntityDialog.unregisterState.unregisterButtonTitle':
          'Trek registratie van locatie in',
        'unregisterEntityDialog.unregisterState.advancedOptions':
          'Geavanceerde opties',
        'unregisterEntityDialog.unregisterState.advancedDescription':
          'Je kunt ook de entiteit zelf uit de catalogus verwijderen. Doe dit alleen als je weet dat het catalogusbestand op de oorspronkelijke locatie is verwijderd of verplaatst. Is dat niet zo, dan verschijnt de entiteit weer zodra de catalogus de volgende keer ververst.',
        'unregisterEntityDialog.errorStateTitle':
          'Interne fout: onbekende status',
        'userListPicker.defaultOrgName': 'Organisatie',
        'userListPicker.personalFilter.title': 'Persoonlijk',
        'userListPicker.personalFilter.ownedLabel': 'Van mij',
        'userListPicker.personalFilter.starredLabel': 'Favorieten',
        'userListPicker.orgFilterAllLabel': 'Alle',
        'entityTableColumnTitle.name': 'Naam',
        'entityTableColumnTitle.system': 'Systeem',
        'entityTableColumnTitle.owner': 'Eigenaar',
        'entityTableColumnTitle.type': 'Type',
        'entityTableColumnTitle.lifecycle': 'Levenscyclus',
        'entityTableColumnTitle.namespace': 'Naamruimte',
        'entityTableColumnTitle.description': 'Beschrijving',
        'entityTableColumnTitle.tags': 'Tags',
        'entityTableColumnTitle.targets': 'Doelen',
        'entityTableColumnTitle.title': 'Titel',
        'entityTableColumnTitle.label': 'Label',
        'entityTableColumnTitle.domain': 'Domein',
        'entityRelationCard.emptyHelpLinkTitle': 'Lees hoe je dit wijzigt.',
        'missingAnnotationEmptyState.title': 'Annotatie ontbreekt',
        'missingAnnotationEmptyState.readMore': 'Meer informatie',
        'missingAnnotationEmptyState.annotationYaml':
          'Voeg de annotatie toe aan de YAML van je {{entityKind}}, zoals in het gemarkeerde voorbeeld hieronder:',
        'missingAnnotationEmptyState.generateDescription_one':
          'De annotatie {{annotations}} ontbreekt. Voeg de annotatie toe aan je {{entityKind}} om deze tool in te schakelen.',
        'missingAnnotationEmptyState.generateDescription_other':
          'De annotaties {{annotations}} ontbreken. Voeg de annotaties toe aan je {{entityKind}} om deze tool in te schakelen.',
      },
    }),
  },
});
